import script from "D:\\Games\\van\\van3\\v3\\ui\\GamePage.vue?type=script"
export * from "D:\\Games\\van\\van3\\v3\\ui\\GamePage.vue?type=script"

import "D:\\Games\\van\\van3\\v3\\ui\\GamePage.vue?type=style&index=0"
export default script
script.__scopeId = "data-v-0ca84707"